import CourseCard from '@my-pages/features/courses/components/CourseCard.tsx';
import NoBookedCourses from '@my-pages/features/courses/components/NoBookedCourses.tsx';
import { MemberBooking } from '@shared/integrations/taf-api/v1/models';

interface IProps {
    bookings?: MemberBooking[];
}

const BookedCoursesCard = ({ bookings }: IProps) => {
    const bookedCourses = bookings?.filter((course) => !course.hasParticipated);
    return (
        <div className='card card-body mb-4'>
            <h3>Bokade kurser</h3>
            {bookedCourses && bookedCourses.length > 0 ? (
                <div className='row'>
                    {bookedCourses?.map((course, key) => (
                        <CourseCard
                            course={course}
                            key={key}
                        />
                    ))}
                </div>
            ) : (
                <NoBookedCourses />
            )}
        </div>
    );
};

export default BookedCoursesCard;
